export default __webpack_public_path__ + "static/media/Nilfisk FOOD.37549567.png";